var $ = require('jQuery');
var tectoastr = require('tectoastr');
var Dialog = require('./dialog.js');

/**
 * Submit new comment, edit or delete existing comments.
 *
 * Usage:
 *   Comments(elements);
 *
 * elements -> a jQuery object that points to all elements containing comments.
 *             Usually the elements will hold contents of comments.comments
 *             partial and be displayed in the view with the help of HTML::comments()
 *             macro.
 * 
 */
module.exports = function (elements) {

    var debug = false;

    /**
     * A helper function for handling errors.
     */
    var handleErrors = function(error) {
        if (error.responseJSON) {

            // the 'comment' field validation failed?
            if (error.responseJSON.hasOwnProperty('comment')) {
                $.each(error.responseJSON.comment, function(key, err) {
                    tectoastr.error(err);
                });
                return;
            }

            if (error.responseJSON.message) {
                tectoastr.error(error.responseJSON.message);
                return;
            }
        }

        // generic error message
        tectoastr.error($('#lang-strings #alerts-generic').text());
    };

    /**
     * Creating new comments.
     */
    var newCommentBehaviour = (function() {

        /**
         * Expand the textarea on focus and show the Save button.
         */
        var newComment = function(element) {
            var form = element.find('.comment-new');
            var route = form.find('input[name="route"]').val();
            var textarea = form.find('textarea');
            var submitButton = form.find('.comment-action-add');
            var commentList = element.find('.comment-list');
            var focusOutTimeout;

            textarea.on('focus', function() {
                var textarea = $(this);

                // expand the textarea
                textarea.removeClass('compact');
                textarea.siblings('.comment-action-add').removeClass('hidden');
            });

            textarea.on('focusout', function() {
                var textarea = $(this);

                focusOutTimeout = setTimeout(function() {
                    // only shrink the textarea if it's empty
                    if (!$(textarea).val()) {
                        textarea.addClass('compact');
                        textarea.siblings('.comment-action-add').addClass('hidden');                        
                    }
                }, 200);
            });

            submitButton.on('click', function(e) {
                e.preventDefault();

                var data = {
                    'comment': form.find('textarea[name="comment"]').val(),
                    'token': form.find('input[name="token"]').val(),
                };

                clearTimeout(focusOutTimeout);

                submitButton.prop('disabled', true);

                $.ajax({
                    'type': 'POST',
                    'url': route,
                    'dataType': 'json',
                    'timeout': 10000,
                    data: data

                }).done(function(response) {
                    if (debug) console.log(response);

                    commentList.append(response.comment);

                    commentList.find('.comment-container').each(function() {
                        commentBehaviour.bindToElement(element, $(this));
                    });

                    textarea.val('');
                    textarea.addClass('compact');
                    textarea.siblings('.comment-action-add').addClass('hidden');
                    textarea.change();

                }).fail(function(response) {
                    if (debug) console.log(response);

                    handleErrors(response);

                    textarea.focus();

                }).always(function(response) {
                    if (debug) console.log(response);

                    submitButton.prop('disabled', false);

                });
            });

            // textarea was in focus before any events fired?
            if (textarea.is(':focus')) {
                textarea.removeClass('compact');
                textarea.siblings('.comment-action-add').removeClass('hidden');
            }

        }

        var bindToElement = function(element) {
            newComment(element);
        }
     
        // Public API
        return {
            bindToElement: bindToElement
        };
    })();

    /**
     * Updating/deleting existing comments.
     */
    var commentBehaviour = (function() {

        /**
         * Click handler for Edit button.
         */
        var editComment = function(e) {
            e.preventDefault();

            var comment = e.data.comment;

            comment.find('.comment-update').removeClass('hidden');
            comment.find('.comment-text').addClass('hidden');
            comment.find('.comment-meta').addClass('hidden');
        }

        /**
         * Click handler for Save button.
         */
        var saveComment = function(e) {
            e.preventDefault();

            var element = e.data.element;
            var comment = e.data.comment;

            var route = comment.find('input[name="route"]').val();
            var textarea = comment.find('textarea');
            var submitButton = comment.find('.comment-action-save');

            var data = {
                'comment': comment.find('textarea[name="comment"]').val(),
                'token': comment.find('input[name="token"]').val(),
            };

            submitButton.prop('disabled', true);

            $.ajax({
                'type': 'PUT',
                'url': route,
                'dataType': 'json',
                'timeout': 10000,
                data: data

            }).done(function(response) {
                if (debug) console.log(response);

                comment.html(response.comment);

                comment.find('.comment-container').each(function() {
                    commentBehaviour.bindToElement(element, $(this));
                });

                // triggering a change event on a new comment textarea
                // to notify Autosaver of the changes
                element.find('.comment-new textarea').change();

            }).fail(function(response) {
                if (debug) console.log(response);

                handleErrors(response);

                textarea.focus();

            }).always(function(response) {
                if (debug) console.log(response);

                submitButton.prop('disabled', false);

            });
        }

        /**
         * Click handler for Cancel button.
         */
        var cancelEdit = function(e) {
            e.preventDefault();

            e.data.comment.find('.comment-update').addClass('hidden');
            e.data.comment.find('.comment-text').removeClass('hidden');
            e.data.comment.find('.comment-meta').removeClass('hidden');
        }

        /**
         * Click handler for Delete button.
         */
        var deleteComment = function(e) {
            e.preventDefault();

            var element = e.data.element;
            var comment = e.data.comment;

            var route = comment.find('input[name="route"]').val();

            var data = {
                'token': comment.find('input[name="token"]').val(),
            };

            var dialog = new Dialog();

            dialog.show({ content: $('#lang-strings #alerts-delete-comment').text() }, function() {
                $.ajax({
                    'type': 'DELETE',
                    'url': route,
                    'dataType': 'json',
                    'timeout': 10000,
                    data: data

                }).done(function(response) {
                    if (debug) console.log(response);

                    comment.remove();

                    // triggering a change event on a new comment textarea
                    // to notify Autosaver of the changes
                    element.find('.comment-new textarea').change();

                }).fail(function(response) {
                    if (debug) console.log(response);
                });
            });
        }

        var bindToElement = function(element, comment) {
            comment.on('click', '.comment-action-edit', { element: element, comment: comment }, editComment);
            comment.on('click', '.comment-action-delete', { element: element, comment: comment }, deleteComment);
            comment.on('click', '.comment-action-save', { element: element, comment: comment }, saveComment);
            comment.on('click', '.comment-action-cancel', { element: element, comment: comment }, cancelEdit);
        }
     
        // Public API
        return {
            bindToElement: bindToElement
        };
    })();

    for (var i = 0; i < elements.length; i++) {
        var element = $(elements[i]);

        // Bindings
        newCommentBehaviour.bindToElement(element);

        element.find('.comment-container').each(function() {
            commentBehaviour.bindToElement(element, $(this));
        });
    }

    /**
     * Bindings for comment autosaver
     */
    $('.comment-autosave').on('click', function() {
        $('.comment-new textarea').each(function() {
            if ($(this).val().length) {
                $(this).siblings('.comment-action-add').click();
            }
        });
    });
};
